var app = angular.module('leonardo');

var StartFromFilter = function () {
  return function(input, start) {
      start = +start; //parse to int
      return angular.isArray(input) ? input.slice(start) : input;
  }
};

app.filter('startFrom', [StartFromFilter]);
 